import React, { ReactElement } from 'react';
import { Flex, Text } from 'rebass/styled-components';

import { FloatLabelInput, ButtonGroup } from 'ui/patterns';

import Icon from 'assets/icons';

import { TableHeaderType } from './formListType';

export default function TableHeader(props: TableHeaderType): ReactElement {
  const onChangeText = (value: string) => {
    props.headerUpdateCallBack &&
      props.headerUpdateCallBack({ columnId: props.column.id, value });
  };

  let sortedItem;
  if (props.multiSortedItem instanceof Array) {
    sortedItem = props.multiSortedItem.find(
      mItem => mItem.sortKey === props.column.id,
    );
  } else {
    sortedItem = props.multiSortedItem;
  }

  if (props.sortedItem) {
    sortedItem = props.sortedItem;
  }

  const onSortChange = () => {
    props.handleSortChange && props.handleSortChange(props.column.id);
  };
  return (
    <Flex>
      {props.column.id !== 'CID' && props.column.id !== 'Account Name' ? (
        <FloatLabelInput
          style={{ flexGrow: '1' }}
          label={props.column.id}
          onChangeText={onChangeText}
          value={
            (props.columnsSearch && props.columnsSearch[props.column.id]) || ''
          }
        />
      ) : (
        <Text
          mb={2}
          color="text.body"
          sx={{ marginBottom: '-5px', flexGrow: '1' }}
          fontWeight="medium"
        >
          {props.column.id}
        </Text>
      )}
      {props.column.id !== 'CID' && props.column.id !== 'Account Name' ? (
        <ButtonGroup onClick={onSortChange}>
          {sortedItem?.sortKey !== props.column.id && (
            <Icon.Sort title="Sort" />
          )}
          {sortedItem?.sortKey === props.column.id &&
            sortedItem?.sortOrder === 'asc' && <Icon.SortUp title="Sort" />}
          {sortedItem?.sortKey === props.column.id &&
            sortedItem?.sortOrder === 'desc' && <Icon.SortDown title="Sort" />}
        </ButtonGroup>
      ) : null}
    </Flex>
  );
}
